import React, { useState } from "react";
import StatusMonthYearSelector from "./StatusMonthYearSelector";
import ReportTable from "./ReportTable";
import { exportStyledExcel } from "../LoginExcelDownLoads/AuaAuthAnalysis/exportStyledExcel";
import {
  getDistrictWiseReport_New,
  getBlockWiseReport_New,
  getFpsWiseReport_New,
  downloadDistrictWiseExcel_New,
  downloadBlockWiseExcel_New,
  downloadFpsWiseExcel_New,
  downloadRawExcel_New,
} from "../Service/api";

const getMonthName = (monthNumber) => {
  const date = new Date();
  date.setMonth(parseInt(monthNumber, 10) - 1);
  return date.toLocaleString("en-IN", { month: "long" });
};

function ChangeStatment_Report_rpt() {
  const [reportData, setReportData] = useState(null);
  const [blockReportData, setBlockReportData] = useState(null);
  const [fpsReportData, setFpsReportData] = useState(null);

  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedBlock, setSelectedBlock] = useState(null);

  const [currentMonth, setCurrentMonth] = useState("");
  const [currentYear, setCurrentYear] = useState("");
  const [currentStatus, setCurrentStatus] = useState("");

  const [currentMonthName, setCurrentMonthName] = useState("");
  const [currentBlockName, setCurrentBlockName] = useState("");

  const [loading, setLoading] = useState(false);
  const [blockLoading, setBlockLoading] = useState(false);
  const [fpsLoading, setFpsLoading] = useState(false);

  const [error, setError] = useState(null);
  const [blockError, setBlockError] = useState(null);
  const [fpsError, setFpsError] = useState(null);

  const fetchReport = async (month, year, status) => {
    setLoading(true);
    setError(null);
    setReportData(null);
    setBlockReportData(null);
    setFpsReportData(null);
    setSelectedDistrict(null);
    setSelectedBlock(null);

    setCurrentMonth(month);
    setCurrentYear(year);
    setCurrentStatus(status);

    setCurrentMonthName(getMonthName(month));
    setCurrentBlockName("");

    try {
      const data = await getDistrictWiseReport_New(month, year, status);
      setReportData(data);
    } catch (err) {
      setError("Failed to fetch district wise report.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchBlockReport = async (distCode, districtName) => {
    setBlockLoading(true);
    setBlockError(null);
    setBlockReportData(null);
    setFpsReportData(null);
    setSelectedDistrict(distCode);
    setSelectedBlock(null);
    setCurrentBlockName(districtName);

    try {
      const data = await getBlockWiseReport_New(
        distCode,
        currentMonth,
        currentYear,
        currentStatus
      );
      setBlockReportData(data);
    } catch (err) {
      setBlockError("Failed to fetch block wise report.");
      console.error(err);
    } finally {
      setBlockLoading(false);
    }
  };

  const fetchFpsReport = async (distCode, officeCode, blockName) => {
    setFpsLoading(true);
    setFpsError(null);
    setFpsReportData(null);
    setSelectedBlock(officeCode);
    setCurrentBlockName(blockName);

    try {
      const data = await getFpsWiseReport_New(
        distCode,
        officeCode,
        currentMonth,
        currentYear,
        currentStatus
      );
      setFpsReportData(data);
    } catch (err) {
      setFpsError("Failed to fetch FPS wise report.");
      console.error(err);
    } finally {
      setFpsLoading(false);
    }
  };

  const handleDownloadDistrictReport = async () => {
    try {
      const data = await downloadDistrictWiseExcel_New(
        currentMonth,
        currentYear,
        currentStatus
      );

      if (data && data.length > 0) {
        const formattedData = data.map((item) => ({
          "Sl No": item.slNo,
          "District Name": item.districtName,
          "District Code": item.distCode,
          "Total Cards": item.totalCards,
          Addition: item.addition,
          Modification: item.modification,
          Deletion: item.deletion,
        }));

        const fileName = `District_Wise_Report_${currentStatus}_${currentMonth}_${currentYear}.xlsx`;
        const title = `District Wise Report (${currentStatus}) - ${currentMonthName} ${currentYear}`;
        await exportStyledExcel(formattedData, fileName, title);
      } else {
        alert("No data found to download");
      }
    } catch (err) {
      console.error("Download error:", err);
      alert("Failed to download District Report");
    }
  };

  const handleDownloadBlockReport = async () => {
    if (selectedDistrict) {
      try {
        const data = await downloadBlockWiseExcel_New(
          selectedDistrict,
          currentMonth,
          currentYear,
          currentStatus
        );

        if (data && data.length > 0) {
          const formattedData = data.map((item) => ({
            "Sl No": item.slNo,
            "Block Name": item.blockName,
            "Office Code": item.officeCode,
            "Total Cards": item.totalCards,
            Addition: item.addition,
            Modification: item.modification,
            Deletion: item.deletion,
          }));

          const fileName = `Block_Wise_Report_${selectedDistrict}_${currentMonth}_${currentYear}.xlsx`;
          const title = `Block Wise Report (${currentStatus}) - ${currentMonthName} ${currentYear}`;
          await exportStyledExcel(formattedData, fileName, title);
        } else {
          alert("No data found to download");
        }
      } catch (err) {
        console.error("Download error:", err);
        alert("Failed to download Block Report");
      }
    }
  };

  const handleDownloadFpsReport = async () => {
    if (selectedDistrict && selectedBlock) {
      try {
        const data = await downloadFpsWiseExcel_New(
          selectedDistrict,
          selectedBlock,
          currentMonth,
          currentYear,
          currentStatus
        );

        if (data && data.length > 0) {
          const formattedData = data.map((item, index) => ({
            "Sl No": index + 1,
            "FPS ID": item.fpsId,
            "RC ID": item.rcId,
            Block: item.blockName,
            District: item.districtName,
            "Updated Time": item.updatedTime,
            "Change Status": item.changeStatus,
          }));

          const fileName = `FPS_Report_${selectedBlock}_${currentMonth}_${currentYear}.xlsx`;
          const title = `FPS Wise Report (${currentStatus}) - ${currentMonthName} ${currentYear}`;
          await exportStyledExcel(formattedData, fileName, title);
        } else {
          alert("No data found to download");
        }
      } catch (err) {
        console.error("Download error:", err);
        alert("Failed to download FPS Report");
      }
    }
  };

  const handleRawDownload = async (distCode, officeCode) => {
    try {
      const data = await downloadRawExcel_New(
        distCode,
        officeCode,
        currentMonth,
        currentYear,
        currentStatus
      );

      if (data && data.length > 0) {
        const formattedData = data.map((item, index) => ({
          "Sl No": index + 1,
          District: item.districtName,
          Block: item.blockName,
          "FPS ID": item.fpsId,
          "RC ID": item.rcId,
          "Updated Date": item.updatedTime,
          "Change Status": item.changeStatus,
        }));

        const fileName = `Full_Raw_Data_${currentStatus}_${currentMonth}_${currentYear}.xlsx`;
        const title = `Full Raw Data Report (${currentStatus}) - ${currentMonthName} ${currentYear}`;
        await exportStyledExcel(formattedData, fileName, title);
      } else {
        alert("No data found for raw export");
      }
    } catch (err) {
      console.error("Raw download error:", err);
      alert("Failed to download Raw Data");
    }
  };

  const handleTotalClick_StateLevel = async () => {
    await handleRawDownload(null, null);
  };

  const handleTotalClick_DistrictLevel = async () => {
    if (selectedDistrict) {
      await handleRawDownload(selectedDistrict, null);
    }
  };

  const handleTotalClick_BlockLevel = async () => {
    if (selectedDistrict && selectedBlock) {
      await handleRawDownload(selectedDistrict, selectedBlock);
    }
  };

  return (
    <div className="py-6">
      <div className="">
        <StatusMonthYearSelector
          onSubmit={fetchReport}
          heading="Change Statement Report"
        />
      </div>

      {loading && (
        <p className="text-center mt-6 text-blue-600 text-lg font-medium">
          Loading district report...
        </p>
      )}

      {error && (
        <p className="text-center mt-6 text-red-600 text-lg font-medium">
          Error: {error}
        </p>
      )}

      {reportData && !loading && !error && (
        <div className="py-6">
          <ReportTable
            data={reportData}
            mainTitle="Change Statement Report"
            onDistrictClick={fetchBlockReport}
            onDownloadReport={handleDownloadDistrictReport}
            onTotalClick={handleTotalClick_StateLevel}
            monthName={currentMonthName}
            year={currentYear}
            blockName={""}
          />
        </div>
      )}

      {selectedDistrict && (
        <div className="">
          {blockLoading && (
            <p className="text-center text-blue-600 text-lg font-medium">
              Loading block report...
            </p>
          )}
          {blockError && (
            <p className="text-center text-red-600 text-lg font-medium">
              Error: {blockError}
            </p>
          )}
          {blockReportData && !blockLoading && !blockError && (
            <>
              <ReportTable
                data={blockReportData}
                mainTitle="Change Statement Report"
                onBlockClick={fetchFpsReport}
                isBlockTable={true}
                onDownloadReport={handleDownloadBlockReport}
                onTotalClick={handleTotalClick_DistrictLevel}
                monthName={currentMonthName}
                year={currentYear}
                blockName={currentBlockName}
              />

              {selectedBlock && (
                <div className="py-6">
                  {fpsLoading && (
                    <p className="text-center text-blue-600 text-lg font-medium">
                      Loading FPS report...
                    </p>
                  )}
                  {fpsError && (
                    <p className="text-center text-red-600 text-lg font-medium">
                      Error: {fpsError}
                    </p>
                  )}
                  {fpsReportData && !fpsLoading && !fpsError && (
                    <ReportTable
                      data={fpsReportData}
                      mainTitle="Change Statement Report"
                      isFpsTable={true}
                      onDownloadReport={handleDownloadFpsReport}
                      onTotalClick={handleTotalClick_BlockLevel}
                      monthName={currentMonthName}
                      year={currentYear}
                      blockName={currentBlockName}
                    />
                  )}
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default ChangeStatment_Report_rpt;
